import { gql } from "@apollo/client";

export const GET_NOTIFICATIONS = gql`
    query getNotifies($userId:String!, $page:Int, $limit:Int){
        getNotifies(userId:$userId, page:$page, limit:$limit){
            status
            message
            response{
                id
                message
                type
                createdAt
                leadId
                isRead
            }
            unreadCount
            total
        }
    }
`

export const UPDATE_NOTIFY_STATUS = gql`
    mutation updateNotify($userId:String!, $type:String, $notificationId:String){
        updateNotify(userId:$userId, type:$type, notificationId:$notificationId){
            status
            message
        }
    }
`
